import { createStore, applyMiddleware } from 'redux';
import { reducer } from '../reducer';
import thunk from 'redux-thunk';
import NotificationAPI from '../notification_api';

export default function configureStore(urls) {
  const createStoreWithMiddleware = applyMiddleware(
    thunk.withExtraArgument(new NotificationAPI(urls))
  )(createStore);
  return createStoreWithMiddleware(reducer);
}
